import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import BlurbTitle from './BlurbTitle';

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'inline-block'
  },
  logo: {
    width: '140px',
    marginRight: theme.spacing(1),
    marginBottom: '-1px',
    [theme.breakpoints.down('xs')]: {
      width: '120px'
    }
  },
  hr: {
    height: '2px',
    background: `linear-gradient(45deg, ${theme.palette.primary.main} 5%,
      ${theme.palette.secondary.main} 95%)`,
    borderRadius: '1px',
    border: '0px',
    margin: theme.spacing(3, 'auto')
  }
}));

const BlurbTitleUnderlined = (props) => {
  const classes = useStyles(props);
  const { logo, alt } = props;

  return (
    <div className={classes.titleContainer}>
      <BlurbTitle {...props}>
        {logo && (
          <span>
            <img className={classes.logo} src={logo} alt={alt} />
          </span>
        )}
        {props.children}
      </BlurbTitle>
      <hr className={classes.hr} />
    </div>
  );
};

export default BlurbTitleUnderlined;
